import { useMemo } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Callback, GiftMessageSaveInput } from 'lib/types'
import { CHECKOUT_SUBMIT_DELAY } from 'lib/core/resources/constants'
import { getCartId } from 'lib/core/data/quote/cartId/selectors'
import { getGiftMessage } from 'lib/core/data/quote/giftMessage/selectors'
import { saveGiftMessage as _saveGiftMessage } from 'lib/core/data/quote/giftMessageSave'

interface GiftMessageHookOptions {
  callback?: Callback
  debounce?: boolean
}

export const useGiftMessage = () => {
  const dispatch = useDispatch()
  const cartId = useSelector(getCartId)
  const giftMessageSelector = useMemo(() => getGiftMessage(cartId), [cartId])
  const giftMessage = useSelector(giftMessageSelector)

  const saveGiftMessage = useMemo(() => (
    input: Omit<GiftMessageSaveInput, 'cartId'>,
    options?: GiftMessageHookOptions
  ) => {
    if (!cartId) {
      return
    }

    const data = {
      cartId,
      ...input
    }

    if (options?.debounce) {
      clearTimeout(saveGiftMessageDebounce)
      saveGiftMessageDebounce = window.setTimeout(() => {
        dispatch(_saveGiftMessage(data, options?.callback))
      }, CHECKOUT_SUBMIT_DELAY)
    } else {
      dispatch(_saveGiftMessage(data, options?.callback))
    }
  }, [cartId, dispatch])

  return {
    giftMessage,
    saveGiftMessage
  }
}

let saveGiftMessageDebounce: number | undefined
